(() => {
  if (window.aotcGalleryLayoutLoaded) return;
  window.aotcGalleryLayoutLoaded = true;

  const desktop = window.matchMedia("(min-width: 990px)");
  let frame;
  const observed = new WeakSet();

  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(layout);
  }

  const observer = new ResizeObserver(schedule);

  function layout() {
    document.querySelectorAll(".digital-gallery__grid").forEach(grid => {
      const items = Array.from(grid.children);
      const nextRow = [1, 1];

      [grid, ...items].forEach(element => {
        if (!observed.has(element)) {
          observer.observe(element);
          observed.add(element);
        }
      });

      items.forEach((item, index) => {
        if (!desktop.matches) {
          item.style.removeProperty("grid-column");
          item.style.removeProperty("grid-row");
          return;
        }

        let column = index % 2;

// Only move "Pieces" in the 2025 gallery.
if (
  grid.closest("#aotc-gallery-year-2025") &&
  item.querySelector("h2")?.textContent.trim() === "Pieces"
) {
  column = 1;

  const innerSelf = items.find(artwork =>
    artwork.querySelector("h2")?.textContent.trim() === "Inner Self"
  );

  if (innerSelf) {
    const innerSelfRow = parseInt(innerSelf.style.gridRowStart, 10);
    nextRow[1] = Math.max(nextRow[1], innerSelfRow || 1);
  }
}
        const height = Math.max(1, Math.ceil(item.offsetHeight));

        item.style.gridColumn = String(column + 1);
        item.style.gridRow = `${nextRow[column]} / span ${height}`;

        // Leave 40px between artworks in each column.
        nextRow[column] += height + 40;
      });
    });
  }

  window.addEventListener("resize", schedule);
  window.addEventListener("load", schedule);
  document.addEventListener("shopify:section:load", schedule);
  document.addEventListener("shopify:section:reorder", schedule);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedule);
  } else {
    schedule();
  }

  if (document.fonts) document.fonts.ready.then(schedule);
})();